import PreLoader from '../../modules/preloader';

export class DealerApplication {
    constructor() {
        this.mainBox = $('#dealer-application');
        this.userName = this.mainBox.find('[name="userName"]');
        this.companyName = this.mainBox.find('[name="companyName"]');
        this.instagram = this.mainBox.find('[name="instagram"]');
        this.brands = this.mainBox.find('[name="brands"]');
        this.city = this.mainBox.find('[name="city"]');
        this.address = this.mainBox.find('[name="address"]');
        this.phone = this.mainBox.find('[name="phone"]');
        this.email = this.mainBox.find('[name="email"]');
        this.submit = this.mainBox.find('.js-submit');

        this.loader = new PreLoader();
    }

    init() {
        let _self = this;

        this.submit.on('click', function() {
            _self.send();
        });
    }

    send() {
        let _self = this;
        this.loader.show();
        this.hideErrors();
        $.ajax({
            url: '/ajax/action/dealer_application/send/',
            type: 'post',
            data: {
                userName: this.userName.val(),
                companyName: this.companyName.val(),
                instagram: this.instagram.val(),
                brands: this.brands.val(),
                city: this.city.val(),
                address: this.address.val(),
                phone: this.phone.val(),
                email: this.email.val(),
                kindOfActivity: this.mainBox.find('[name="kindOfActivity"]:checked').val()
            },
            success: function(response) {
                _self.loader.hide();
                if (parseInt(response.code) === 400) {
                    let errorList = response.data.ERROR_LIST;
                    if (Object.keys(errorList).length !== 0) {
                        for (const fieldName in errorList) {
                            _self.mainBox
                                .find('[name="' + fieldName + '"]')
                                .next()
                                .text(errorList[fieldName])
                                .show();
                        }
                    }

                    return;
                }

                _self.showResult();
            }
        });
    }

    hideErrors() {
        this.mainBox.find('.form__common-error').hide();
    }

    showResult() {
        $('#dealer-application').hide();
        $('#dealer_application_result').show();
    }
}

document.addEventListener('DOMContentLoaded', function() {
    const dealerApplication = new DealerApplication();
    dealerApplication.init();
});



// WEBPACK FOOTER //
// ./blocks/dealer-application/dealer-application.js